import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Button, Input } from 'antd';
import { OnlineInventoryAPI } from '../../api/onlineInventoryAPI';

interface AdvancedFiltersViewProps {
  onClose: () => void;
  onApplyFilters: (filters: any) => void;
}

const AdvancedFiltersView: React.FC<AdvancedFiltersViewProps> = ({
  onClose,
  onApplyFilters,
}) => {
  const [filters, setFilters] = useState<
    Array<{ label: string; value: string; type: string }>
  >([]);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState<string>('');
  const [appliedFilters, setAppliedFilters] = useState<
    Array<{ label: string; value: string; searchValue: string }>
  >([]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const filtersData = await OnlineInventoryAPI.fetchAdvancedFilters();
        if (Array.isArray(filtersData)) {
          setFilters(filtersData);
        } else {
          console.warn('No se encontraron filtros avanzados.');
        }
      } catch (error) {
        console.error('Error al obtener filtros avanzados:', error);
      }
    };

    fetchFilters();
  }, []);

  const handleApplyFilters = () => {
    if (selectedFilter && searchValue.trim() !== '') {
      // Si el filtro ya existe, reemplazarlo en vez de duplicarlo
      const updatedFilters = [...appliedFilters];
      const existingFilterIndex = updatedFilters.findIndex(f => f.value === selectedFilter);

      if (existingFilterIndex !== -1) {
        updatedFilters[existingFilterIndex] = { label: selectedFilter, value: selectedFilter, searchValue };
      } else {
        updatedFilters.push({ label: selectedFilter, value: selectedFilter, searchValue });
      }

      setAppliedFilters(updatedFilters);
      onApplyFilters(updatedFilters);
    }

    onClose();
  };

  return (
    <Modal title="Filtros avanzados" open={true} onCancel={onClose} footer={null} width={800}>
      <Form layout="vertical">
        <Form.Item label="Filtro">
          <Select
            placeholder="Selecciona un filtro"
            value={selectedFilter}
            onChange={setSelectedFilter}
            style={{ width: "100%" }}
          >
            {filters.map(filter => (
              <Select.Option key={filter.value} value={filter.value}>
                {filter.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {selectedFilter && (
          <Form.Item label="Buscador">
            <Input
              placeholder={`Buscar por ${filters.find(f => f.value === selectedFilter)?.label || "filtro"}`}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Form.Item>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button 
            type="primary" 
            onClick={handleApplyFilters} 
            disabled={!selectedFilter || searchValue.trim() === ""}
          >
            Buscar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AdvancedFiltersView;